










































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { enums } from '@/common/enums';
import DataPanel from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import PaginationPanel from '@/components/PaginationPanel.vue';
import { DraggerImg } from '@/components';
import { formRules } from '@/common/util/validator';
import ImageNumUpload from '@/components/ImageNumUpload.vue';
import BaseContainer from '@/components/BaseContainer.vue';
import PageDescribe from '@/components/PageDescribe.vue';
import { UserApi, PriceList, Inquiry, Carrier } from '@/http';
import { MessageBox, Message } from 'element-ui';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: { DataPanel, PaginationPanel, ImageNumUpload, BaseContainer, PageDescribe, SearchPanel, DraggerImg },
})
export default class freightConfig extends Vue {
    public formRules = formRules;
    public statusType = enums.statusType;
    public priceListType = enums.priceListType;

    public dialogVisible = false;
    public carrierList: any = [];
    //根据权限判断按钮显隐
    public pzyb3: boolean = false;
    public pzys3: boolean = false;
    public pzysx3: boolean = false;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.pzyb3 = webMenus.includes('pzyb3');
        this.pzys3 = webMenus.includes('pzys3');
        this.pzysx3 = webMenus.includes('pzysx3');
    }
    public handleClose() {
        this.formData = { carrierId: '', priceListType: 1 };
        this.$refs.formData.resetFields();
        this.dialogVisible = false;
    }
    public async save() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                console.log('this.currentBt' + JSON.stringify(this.currentBtn));

                if (this.formData.priceListType == 1) {
                    if (this.currentBtn.length == 0) {
                        this.$message.warning('请选择车长!');
                        return;
                    }
                }
                if (this.formData.priceListType == 3) {
                    if (this.currentBtn2.length == 0) {
                        this.$message.warning('请选择吨位范围!');
                        return;
                    }
                }
                let result = await PriceList.CheckPriceListInPeriod({
                    carrierId: this.formData.carrierId,
                    beginDate: this.formData.beginDate,
                    endDate: this.formData.endDate,
                    priceListType: this.formData.priceListType,
                });
                if (result) {
                    this.$alert('该承运商运价表与已有运价表的有效期存在重合，确定新增？');
                }

                // delete this.formData.carLength;
                delete this.formData.time;
                let temp = [];
                if (this.formData.priceListType == 1) {
                    temp = this.currentBtn;
                } else if (this.formData.priceListType == 3) {
                    temp = this.currentBtn2;
                } else {
                    temp = ['单价'];
                }
                this.formData.titleList = temp;
                console.log('this.formData' + JSON.stringify(this.formData));
                let res = await PriceList.AddPriceList(this.formData);
                console.log('res' + JSON.stringify(res));
                this.handleClose();
                this.loadData();
                this.$router.push({
                    path: '/freightEdit',
                    query: {
                        id: res.extData,
                    },
                });
            }
        });
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'carrierName':
                {
                    this.searchValue.orderBy = 'carrierName';
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 'creationTime';
                }
                break;
        }
        this.loadData();
    }

    public formData: any = { priceListType: 1 };
    public carLengthList: any = [];
    public currentBtn: any = [];
    // public webMenus: string = '';
    // public isEdit: boolean = false;
    // public isEffect: boolean = false;
    // public isUneffect: boolean = false;

    async mounted() {
        this.$refs.draggerImg.imgdrager();
        // this.webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        // this.isEdit = this.webMenus.includes('pzyb3') ? true : false;
        // console.log('this.isEdit======>', this.isEdit);
        // this.isEffect = this.webMenus.includes('pzys3') ? true : false;
        // this.isUneffect = this.webMenus.includes('pzysx3') ? true : false;
        if (sessionStorage.getItem('freightConfig_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('freightConfig_searchValue'));
        }
        this.searchPagin = sessionStorage.getItem('freightConfig_page') ? JSON.parse(sessionStorage.getItem('freightConfig_page')) : this.searchPagin;
        console.log('this.searchPagin' + JSON.stringify(this.searchPagin));
        this.loadData();

        let res = await Carrier.GetList({ count: -1 });
        this.carrierList = res.data;
        this.getCarLength();
        this.getTonnageRange();

        this.$refs.pagination.setPage(this.searchPagin.currentPage);
    }

    public tonnageRangeList: any = [];
    public currentBtn2: any = [];
    getTonnageRange() {
        Inquiry.GetDicDetailList({ typeName: 'tonnageRange', count: -1 }).then((res) => {
            this.tonnageRangeList = res.map((v) => {
                return v.name;
            });
            this.currentBtn2 = JSON.parse(JSON.stringify(this.tonnageRangeList));
        });
    }

    getCarLength() {
        Inquiry.GetDicDetailList({ typeName: 'carLength', count: -1 }).then((res) => {
            this.carLengthList = res.map((v) => {
                return v.name;
            });
            this.currentBtn = JSON.parse(JSON.stringify(this.carLengthList));
        });
    }
    updateBtn(item, index) {
        console.log('this.currentBtn' + JSON.stringify(this.currentBtn));
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
    }
    updateBtn2(item, index) {
        console.log('this.currentBtn2' + JSON.stringify(this.currentBtn2));
        if (this.currentBtn2.includes(item)) {
            this.currentBtn2.splice(this.currentBtn2.indexOf(item), 1);
        } else {
            this.currentBtn2.push(item);
        }
    }

    public datetimerange(v) {
        if (v) {
            this.formData.beginDate = v[0];
            this.formData.endDate = v[1];
        } else {
            this.formData.beginDate = null;
            this.formData.endDate = null;
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        formData: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public rePagin: boolean = false;
    public total: number = 0;
    public labelPosition: string = 'right';
    public title: string = '';

    public form: any = {};
    public searchValue: any = {
        carrierName: '',
        pricelistStatus: '',
    };
    public loading: boolean = false;
    public listData = [];

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('freightConfig_page', JSON.stringify(pagin));
        this.loadData();
    }
    public async loadData() {
        this.loading = true;
        await PriceList.GetPriceListList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.listData = res.data;
                let skip = this.searchPagin.skip;
                this.listData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
        if (this.total > 0 && this.listData.length == 0) {
            this.searchPagin.skip = 0;
            this.loadData();
        }
    }
    public search() {
        sessionStorage.setItem('freightConfig_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public reset() {
        this.searchValue = {
            carrierName: '',
            pricelistStatus: '',
        };
        this.$refs.pagination.resetSize();
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.handleSizeChange(10);
        this.search();
    }
    public colData = JSON.parse(sessionStorage.getItem('freightConfig_colData'))
        ? JSON.parse(sessionStorage.getItem('freightConfig_colData'))
        : [
              { title: '序号', isShow: true, disabled: false },
              { title: '用户名', isShow: true, disabled: false },
              { title: '姓名', isShow: true, disabled: false },
              { title: '手机号', isShow: true, disabled: false },
              { title: '用户类型', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        sessionStorage.setItem('freightConfig_colData', JSON.stringify(this.colData));
    }
    tableRowClassName({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
            return '';
        }
        return 'success-row';
    }
    public addNew() {
        this.form = { carLength: '1' };
        // this.$refs.formData.resetFields();
        this.dialogVisible = true;
    }
    public edit(row) {
        this.$router.push({
            path: '/freightEdit',
            query: {
                id: row.id,
            },
        });
    }
    public toDetail(row) {
        this.$router.push({
            path: '/freightDetail',
            query: {
                id: row.id,
                name: 'detail',
            },
        });
    }
    public effective(row) {
        this.$confirm('确认立即生效运价表?', '运价表生效', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                PriceList.PriceListTakeEffect(row.id).then(() => {
                    this.$message.success('运价表生效成功!');
                    this.loadData();
                });
            })
            .catch(() => {});
    }
    public row3: string;
    public unEffective(row) {
        this.row3 = row.id;
        this.dialogConfig3 = {
            title: '失效运价表',
            show: true,
        };
        // this.$confirm('确认立即失效运价表?', '运价表失效', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         PriceList.PriceListLoseEfficacy(row.id).then(() => {
        //             this.$message.success('运价表失效成功!');
        //             this.loadData();
        //         });
        //     })
        //     .catch(() => {});
    }
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfig3 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }

    public row2: string;
    public del(row) {
        this.row2 = row.id;
        this.dialogConfig2 = {
            title: '删除运价表',
            show: true,
        };
        // this.$confirm('确认删除该运价表?', '删除运价表', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         PriceList.DeletePriceList(row.id).then(() => {
        //             this.$message.success('运价表删除成功!');
        //             this.loadData();
        //         });
        //     })
        //     .catch(() => {});
    }
    confirmOk2() {
        PriceList.DeletePriceList(this.row2).then(() => {
            this.$message.success('运价表删除成功!');
            this.loadData();
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmOk3() {
        PriceList.PriceListLoseEfficacy(this.row3).then(() => {
            this.$message.success('运价表失效成功!');
            this.loadData();
        });
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
}
